<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <Topbar ref="con1" @inid="inid" v-if="typeControlPermission" />
        <span v-else v-text="'�z�S���޲z�v��'"></span>
      </div>
    </div>
  </div>        
</template>
<script>
import { mapState } from "vuex";
import Topbar from "./uscontrol/Act_topbar.vue"


export default {
  name: 'Act_my',   
  components: {
    Topbar,
  },
  data() {
    return {
      data: [],
    };
  },
  computed: {
    ...mapState("account", ["status", "user"]),
    ...mapState("makeorg", ["defaultval"]),
      typeControlPermission() {
        const currentVal = this.$route.name;
        // ���o acts_permissions �}�C�A�q defaultval.permissions.acts_permissions
        const acts_permissions = this.defaultval?.permissions?.acts_permissions || [];
        // ��� vals �� Advancementoption ���D�\��
        const adv = acts_permissions.find(item => item.vals === "Actmanagement");
        if (!adv) return null;
        // �b�� acts_detailpermission �̧� vals �� Type_control ���Ӷ�
        return adv.acts_detailpermission.find(d => d.vals === currentVal) || null;
      }    
  },
  mounted() {
  },
  methods: {
    inid(){
      this.$refs["con2"].inid()
    }
  },
  beforeRouteLeave(to, from, next) {
    if(to.name!=='Act_date'){
      window.sessionStorage.removeItem('queryTableState');
      window.sessionStorage.removeItem('queryNewTabIndex');
    }
    next();
  }, 

};
</script>